import { TextField as TextFieldMui } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled('div')(() => ({
  alignItems: 'center',
  display: 'flex',
  gap: 'var(--spacing-small)',
}));

export const TextField = styled(TextFieldMui)(() => ({
  '& .MuiInputBase-input': {
    /**
     * Override global padding for textfield to mimick size="small" padding
     *
     * @todo Find a better way to do this
     * @see ~/src/styles/mui/components/MuiFilledInput.ts
     */
    padding: '8.5px 14px',
  },
}));
